var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRate = function SvgRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.364 29.947a.4.4 0 0 0-.55-.581l.55.58ZM6.829 42.743l13.535-12.796-.55-.581L6.28 42.162l.55.58ZM53.4 15.508a.4.4 0 0 0-.392-.408l-3.6-.07a.4.4 0 0 0-.015.8l3.2.062-.064 3.2a.4.4 0 0 0 .8.015l.07-3.6Zm-13.123 12.78 13-12.5-.554-.576-13 12.5.554.576ZM37.5 27.9a.4.4 0 0 0 0-.8v.8Zm-15 0h15v-.8h-15v.8Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.684 29.534a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM21.383 29.534a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.008 63.715V46.5h4.506",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.602 55.715v-.092M44.988 55.715v-.092",
    stroke: "#000",
    strokeWidth: 1.538,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 63.715V51.99h4M17.5 63.715V48.99h4.506",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "rate_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 42,
    width: 37,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M26.34 42.5h36v21h-36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rate_svg__a)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.74,
    y: 44.9,
    width: 32.2,
    height: 18.932,
    rx: 1.71,
    fill: "#E6FEE2",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.895 47.282h21.892c.197 0 .43.178.543.508a2.788 2.788 0 0 0 1.722 1.722c.33.113.508.346.508.543v8.963c0 .197-.179.43-.508.543a2.788 2.788 0 0 0-1.722 1.722c-.114.33-.346.508-.543.508H31.895c-.197 0-.429-.178-.543-.508a2.788 2.788 0 0 0-1.722-1.722l-.13.378.13-.378c-.329-.113-.507-.346-.507-.543v-8.963c0-.197.178-.43.507-.543a2.788 2.788 0 0 0 1.723-1.723c.113-.329.345-.507.542-.507Z",
    fill: "#E6FEE2",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.619,
    cy: 54.706,
    r: 4.945,
    fill: "#58B847",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.209,
    cy: 54.707,
    r: 1.519,
    fill: "#58B847",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.029,
    cy: 54.707,
    r: 1.519,
    fill: "#58B847",
    strokeWidth: 0.7
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.5v58h58",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRate;